import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { LargeOnly, DownloadButton, ReportLink, Loading } from "commons";

export class TransactionDownloads extends Component {
    render() {
        return (
            <LargeOnly enabled={this.props.isClientPortal}>
                <Container hide={this.props.loading}>
                    <PrintLoading displayWhen={!this.props.isPrinting}>
                        <DownloadButton>
                            <Ul>
                                <Li>
                                    <ReportLink onClick={this.props.onPrintCSV}>
                                        Download CSV
                                    </ReportLink>
                                </Li>
                                <Li>
                                    <ReportLink onClick={this.props.onPrint}>
                                        Download PDF
                                    </ReportLink>
                                </Li>
                            </Ul>
                        </DownloadButton>
                    </PrintLoading>
                </Container>
            </LargeOnly>
        );
    }
}

TransactionDownloads.propTypes = {
    isClientPortal: PropTypes.bool,
    loading: PropTypes.bool,
    onPrint: PropTypes.func,
    onPrintCSV: PropTypes.func,
    isPrinting: PropTypes.bool
};

const Container = styled.div`
    float: right;
    position: relative;
    left: 18px;
    margin-top: 0;
    width: 15%;

    ${props => props.hide && "visibility: hidden;"}
`;

export const Li = styled.li`
    padding: 2px 0;
    margin: 5px 0;
`;

export const Ul = styled.ul`
    list-style-type: none;
    padding: 0;
    margin-top: 1px;
`;

export const PrintLoading = styled(Loading)`
    margin-top: 10px;
    margin-right: 15px;
    float: right;
`;
